import Repository from '../repository';
import store from '../store';

const resource = '/order';

export default {
  get(params = {}) {
    return Repository.get(`${resource}`, {
      params: {
        lang: store.getters['auth/user'].locale || 'th',
        ...params,
      },
    });
  },
  store(order) {
    return Repository.post(`${resource}`, order);
  },
  getById(orderId, params = {}) {
    return Repository.get(`${resource}/${orderId}`, {
      params: {
        lang: store.getters['auth/user'].locale || 'th',
        ...params,
      },
    });
  },
  cancel(orderId, data = {}) {
    return Repository.post(`${resource}/${orderId}/cancel`, data);
  },
};
